export const TIPO_COBERTURA_ANTICIPO = {
    PORCENTAJE_PLAN_PAGO: 810,
    CAUSIDICOS: 811,
    CAUSIDICOS_APORTES: 812,
    CAUSIDICOS_APORTES_HONORARIOS: 813
}
